module.exports = __webpack_public_path__ + "bdb97794699ff9ae5117ac4f40aae5f7.svg";